import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/leads")({
  beforeLoad: ({ context }) => requireRoute(context, "/leads"),
});
